import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/graphics/icon_menu.png'
import _imports_1 from '../../assets/club-logo.png'
import _imports_2 from '../../assets/images/graphics/icon_menu_close.png'
import _imports_3 from '../../assets/Jazz_Club_Logo_1.png'


const _withScopeId = n => (_pushScopeId("data-v-2b1de755"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "navigation-bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  id: "menu-icon",
  alt: "Club Logo"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "menu-icon-text" }, " UBC JAZZ CLUB ", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<li class=\"space\" data-v-2b1de755></li><li data-v-2b1de755><a href=\"/\" data-v-2b1de755>Home</a></li><li data-v-2b1de755><div class=\"dropdown\" data-v-2b1de755><a href=\"/about\" data-v-2b1de755>About</a><div class=\"dropdown-list hide\" data-v-2b1de755><a class=\"option\" href=\"/about\" data-v-2b1de755>who are we?</a><a class=\"option\" href=\"/team\" data-v-2b1de755>our team</a></div></div></li><li data-v-2b1de755><a href=\"/gallery\" data-v-2b1de755>Gallery</a></li><li data-v-2b1de755><a href=\"/contact\" data-v-2b1de755>Book/Contact</a></li>", 5)
const _hoisted_13 = { class: "side-menu-wrapper hide" }
const _hoisted_14 = { class: "side-menu" }
const _hoisted_15 = { class: "menu-items-wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item first" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "home")
], -1))
const _hoisted_17 = { class: "menu-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/about" }, "about us", -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"side-dropdown none\" data-v-2b1de755><div class=\"menu-item\" data-v-2b1de755><a href=\"/team\" data-v-2b1de755> our team </a></div></div><div class=\"menu-item\" data-v-2b1de755><a href=\"/gallery\" data-v-2b1de755>gallery</a></div><div class=\"menu-item\" data-v-2b1de755><a href=\"/contact\" data-v-2b1de755>book/contact</a></div>", 3)
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_3
}, null, -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("ul", null, [
        _createElementVNode("div", {
          class: "mobile_icon",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.displayMenu()))
        }, _hoisted_3),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            href: "/",
            id: "logo",
            class: _normalizeClass({ hide : _ctx.iToggle })
          }, _hoisted_7, 2)
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("img", {
            class: "close-btn",
            src: _imports_2,
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.displayMenu()))
          }),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", {
                class: "arrow left",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.displayDrop()))
              })
            ]),
            _hoisted_19
          ]),
          _hoisted_22
        ])
      ])
    ])
  ]))
}